import {Link} from "react-router-dom";

export default (props) => {

    let get_block_href = (props) => {
        return (
            <a href={props.outLink} className="none">
                <img src={props.imgFile} alt={props.sub}/>
                <br/>
                <span className="sub">{props.sub}</span>
            </a>
        );
    }

    let get_block_link = (props) => {
        return (
            <Link to={props.toLink} className="none">
                <img src={props.imgFile} alt={props.sub}/>
                <br/>
                <span className="sub">{props.sub}</span>
            </Link>
        );
    }

    let view = (props.outLink != undefined) ? get_block_href(props) : get_block_link(props);

    return (
        <>
            <div className="three-col-cell gallery">{view}</div>
        </>
    );
}